import { useNavigate } from 'react-router-dom'
import {
  CAPCreditsTableRow,
  CAPParentContainer,
  CAPPurchaseTableRow,
  ProfileSectionGenericHeading,
} from './CreditsAndPurchasesStyles'
import { useEffect, useState } from 'react'
import { getData } from 'src/consumer/services/profileService'
import { useSelector, useDispatch } from 'react-redux'
import { Spinner } from 'react-bootstrap'
import RefreshIcon from '@mui/icons-material/Refresh'
import { getDataWithoutParams, getFeatureItemBySlug } from 'src/consumer/services/featureServices'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import dayjs from 'dayjs'
import { appVersion, platformWeb, getCountryCode } from 'src/consumer/services'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import { selectUserCreditsData, selectUserPurchasesData, setUserCreditsData, setUserPurchasesData } from 'src/consumer/reducers/personalData/personalDataReducer'

export default function CreditsAndPurchases() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [loadingData, setLoadingData] = useState(false)
  const [userPacks, setUserPacks] = useState([])
  const [userPackConsumptions, setUserPackConsumptions] = useState([])
  const userCreditsDataFromStore = useSelector(selectUserCreditsData)
  const userPurchasesDataFromStore = useSelector(selectUserPurchasesData)

  async function callAPIs(force = false) {
    setLoadingData(true)
    if (force ? true : !Boolean(userCreditsDataFromStore)) {
      const response = await getData('/api/secure/wallet/user/credits')
      if (response?.status === 200 && Array.isArray(response?.data)) {
        dispatch(setUserCreditsData(response?.data))
      }
    }
    if (force ? true : !Boolean(userPurchasesDataFromStore)) {
      const responseTwo = await getData('/api/secure/wallet/user/purchases')
      if (responseTwo?.status === 200 && Array.isArray(responseTwo?.data)) {
        dispatch(setUserPurchasesData(responseTwo?.data))
      }
    }
    const packsResponse = await getData('/api/secure/wallet/user/packs')
    if (packsResponse?.status === 200 && Array.isArray(packsResponse?.data)) {
      setUserPacks(packsResponse?.data)
    }
    const packConsumptionsResponse = await getData('/api/secure/wallet/user/pack-consumptions')
    if (packConsumptionsResponse?.status === 200 && Array.isArray(packConsumptionsResponse?.data)) {
      setUserPackConsumptions(packConsumptionsResponse?.data)
    }
    setLoadingData(false)
  }

  useEffect(() => {
    callAPIs(false)
  }, [])

  return (
    <CAPParentContainer>
      <ProfileSectionGenericHeading style={{ marginBottom: '40px' }}>
        Your Packs, Credit Vouchers and Purchases
        <div style={{ marginLeft: '5px' }}>
          <RefreshIcon style={{ cursor: 'pointer' }} onClick={() => callAPIs(true)} />
        </div>
      </ProfileSectionGenericHeading>
      <div>
        <b>Your Credit Vouchers</b>
        <div>
          {loadingData ? (
            <Spinner animation="border" variant="light" size="sm" />
          ) : (
            <div style={{ paddingTop: '20px' }}>
              {Array.isArray(userCreditsDataFromStore) && userCreditsDataFromStore?.length > 0 ? (
                <>
                  <CAPCreditsTableRow>
                    <div data-label="No.">
                      <b>No.</b>
                    </div>
                    <div data-label="Pack Name">
                      <b>Pack Name</b>
                    </div>
                    <div data-label="Type">
                      <b>Type</b>
                    </div>
                    <div data-label="Expires">
                      <b>Expires</b>
                    </div>
                  </CAPCreditsTableRow>
                  {separateCountCreditsIntoIndividualCredits(userCreditsDataFromStore)?.map(
                    (item, index) => (
                      <CreditItem key={index} data={item} number={index + 1} />
                    ),
                  )}
                </>
              ) : (
                'No Credits'
              )}
            </div>
          )}
        </div>
      </div>
      <div>
        <b>Your Packs</b>
        <div style={{ paddingTop: '20px' }}>
          {loadingData ? (
            <Spinner animation="border" variant="light" size="sm" />
          ) : Array.isArray(userPacks) && userPacks?.length > 0 ? (
            <>
              <CAPPurchaseTableRow>
                <div data-label="No.">
                  <b>No.</b>
                </div>
                <div data-label="Title">
                  <b>Title</b>
                </div>
                <div data-label="Usage">
                  <b>Usage</b>
                </div>
                <div data-label="Expires">
                  <b>Expires</b>
                </div>
              </CAPPurchaseTableRow>
              {userPacks?.map((item, index) => (
                <PackItem key={item?.id || index} data={item} number={index + 1} />
              ))}
            </>
          ) : (
            'No Packs'
          )}
        </div>
      </div>
      <div>
        <b>Recent Pack Usage</b>
        <div style={{ paddingTop: '20px' }}>
          {loadingData ? (
            <Spinner animation="border" variant="light" size="sm" />
          ) : Array.isArray(userPackConsumptions) && userPackConsumptions?.length > 0 ? (
            <>
              <CAPPurchaseTableRow>
                <div data-label="No.">
                  <b>No.</b>
                </div>
                <div data-label="Title">
                  <b>Pack Purchase</b>
                </div>
                <div data-label="Type">
                  <b>Usage</b>
                </div>
                <div data-label="Expires">
                  <b>Consumed On</b>
                </div>
              </CAPPurchaseTableRow>
              {userPackConsumptions?.slice(0, 10)?.map((item, index) => (
                <PackConsumptionItem key={item?.id || index} data={item} number={index + 1} />
              ))}
            </>
          ) : (
            'No Pack Usage Yet'
          )}
        </div>
      </div>
      <div>
        <b>Your Purchases</b>
        <div style={{ paddingTop: '20px' }}>
          {loadingData ? (
            <Spinner animation="border" variant="light" size="sm" />
          ) : (
            <div>
              {Array.isArray(userPurchasesDataFromStore) &&
              userPurchasesDataFromStore?.length > 0 ? (
                <>
                  <CAPPurchaseTableRow>
                    <div data-label="No.">
                      <b>No.</b>
                    </div>
                    <div data-label="Title">
                      <b>Title</b>
                    </div>
                    <div data-label="Type">
                      <b>Type</b>
                    </div>
                    <div data-label="Expires">
                      <b>Expires</b>
                    </div>
                  </CAPPurchaseTableRow>
                  {userPurchasesDataFromStore?.map((item, index) => (
                    <PurchaseItem key={index} data={item} number={index + 1} />
                  ))}
                </>
              ) : (
                'No Purchases'
              )}
            </div>
          )}
        </div>
      </div>
    </CAPParentContainer>
  )
}

const CreditItem = ({ data, number }) => {
  const [serverData, setServerData] = useState()
  async function getAndSetData() {
    const response = await getDataWithoutParams(
      `/api/subscription-plan?id=${data?.pricingPackId}&zoneOffset=${encodeURIComponent(
        getTimezoneOffset(),
      )}&appVersion=${appVersion}&platformType=${platformWeb}&languageCode=${sessionStorage.getItem(
        'languageCode',
      )}&platform=${platformWeb}&countryCode=${getCountryCode()}`,
    )
    if (response?.status === 200 && response?.data) {
      setServerData(response?.data)
    }
  }

  useEffect(() => {
    getAndSetData()
  }, [])

  return (
    <CAPCreditsTableRow>
      <div data-label="No.">
        {number}
      </div>
      <div data-label="Pack Name">
        {serverData?.title || data?.pricingPackId}
      </div>
      <div data-label="Type">
        {data?.itemType === 'amhm-event' ? 'Session Booking' : ''}
      </div>
      <div data-label="Expires">
        {dayjs(data?.creditExpiryTime, 'YYYY-MM-DD HH:mm:ss')?.format('DD MMM YYYY')}
      </div>
    </CAPCreditsTableRow>
  )
}

const PurchaseItem = ({ data, number }) => {
  console.log(data)
  const navigate = useNavigate()
  const [serverData, setServerData] = useState()
  async function getAndSetData() {
    if (data?.itemId && data?.itemType) {
      const response = await getFeatureItemBySlug(data?.itemType, data?.itemId, false, {})
      if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
        setServerData(response?.data?.data?.[data?.itemType])
      }
    }
  }

  useEffect(() => {
    getAndSetData()
  }, [])

  return (
    <CAPPurchaseTableRow>
      <div data-label="No.">
        {number}
      </div>
      <div data-label="Title">
        {data?.itemType === 'course' ? serverData?.title || data?.item?.id : ''}
        {data?.itemType === 'amhm-event' ? 'Event Booking' : ''}
      </div>
      <div data-label="Type">
        {data?.itemType === 'amhm-event' ? 'Session Booking' : ''}
        {data?.itemType === 'course' ? 'Course' : ''}
      </div>
      <div data-label="Expires">
        {data?.itemType !== 'amhm-event'
          ? dayjs(data?.purchaseExpiry, 'YYYY-MM-DD HH:mm:ss')?.format('DD MMM YYYY')
          : ''}
      </div>
    </CAPPurchaseTableRow>
  )
}

const PackItem = ({ data, number }) => {
  const progress = data?.packProgress
  return (
    <CAPPurchaseTableRow>
      <div data-label="No.">
        {number}
      </div>
      <div data-label="Title">
        {progress?.title || data?.bundlePack?.title || data?.id}
      </div>
      <div data-label="Usage">
        {progress?.message ||
          `${progress?.consumedUnits || 0} of ${progress?.totalUnits || 0} used`}
      </div>
      <div data-label="Expires">
        {data?.expiresAt
          ? dayjs(data?.expiresAt, 'YYYY-MM-DD HH:mm:ss')?.format('DD MMM YYYY')
          : data?.status || ''}
      </div>
    </CAPPurchaseTableRow>
  )
}

const PackConsumptionItem = ({ data, number }) => {
  return (
    <CAPPurchaseTableRow>
      <div data-label="No.">
        {number}
      </div>
      <div data-label="Title">
        {data?.bundlePackPurchaseId}
      </div>
      <div data-label="Type">
        {data?.afterConsumedUnits != null && data?.afterRemainingUnits != null
          ? `${data?.afterConsumedUnits} used, ${data?.afterRemainingUnits} remaining`
          : '1 session used'}
      </div>
      <div data-label="Expires">
        {data?.consumedAt
          ? dayjs(data?.consumedAt, 'YYYY-MM-DD HH:mm:ss')?.format('DD MMM YYYY')
          : ''}
      </div>
    </CAPPurchaseTableRow>
  )
}

function separateCountCreditsIntoIndividualCredits(userCreditsDataFromStore) {
  const toReturn = []

  userCreditsDataFromStore?.forEach((item) => {
    const { numberOfCredits, ...rest } = item
    for (let i = 0; i < numberOfCredits; i++) {
      toReturn.push(rest)
    }
  })

  return toReturn
}
